import React from "react";
import styles from "./ChatHeader.module.css";
import { useSelector } from "react-redux";
import defaultProfilePic from "@/assets/default-icon.jpg";
import StatusDropdown from "@/modules/vendor/components/StatusUpdateComponent"
import { ROLES } from "@/constants/data.const";
import { Avatar } from "@mui/material";

function ChatHeader({ conversationId, chatUser }) {
  const { first_name, last_name, profile_picture } = chatUser || {};
  const fullName = `${first_name} ${last_name}`;
  const userAvatar = profile_picture?.file_url || defaultProfilePic;
  const auth = useSelector(state => state.auth.auth);

  return (
    <header className={styles.headerContainer}>
      <div className={styles.headerBackground}>
      </div>
      <div className={styles.headerContent}>
        <div className={styles.userInfo}>
          <Avatar
            src={userAvatar}
            alt={`${first_name || "User"} avatar`}
            sx={{ bgcolor: "primary.main", height: "30px", width: "30px" }}
          />
          <h2 className={styles.userName}>{fullName}</h2>
        </div>
        {auth && auth.role === ROLES.VENDOR && <StatusDropdown conversationId={conversationId} user={chatUser} />}
      </div>
    </header>
  );
}

export default ChatHeader;